import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from 'app/layout/services/dashboard.service';
import { Chart, ChartConfiguration, ArcElement, ChartType, Tooltip, Legend, Title, CategoryScale, PieController, registerables } from 'chart.js';
import { DashboardChartService } from 'app/layout/services/dashboard-chart.service';

Chart.register(PieController, ArcElement, Tooltip, Legend, Title, CategoryScale, ...registerables);

@Component({ standalone: false,
    selector: 'tier-three-dashboard',
    templateUrl: './tier-three-dashboard.component.html',
    styleUrls: ['./tier-three-dashboard.component.scss']
})
export class TierThreeDashboardComponent implements AfterViewInit {

    caseTypesChart!: Chart;
    @ViewChild('caseTypesCanvas') caseTypesCanvas!: ElementRef<HTMLCanvasElement>;
    public caseTypesContext: any;

    casesTotalChart!: Chart;
    @ViewChild('casesTotalsCanvas') casesTotalsCanvas!: ElementRef<HTMLCanvasElement>;
    public casesTotalContext: any;

    caseCategoriesChart!: Chart;
    @ViewChild('caseCategoriesCanvas') caseCategoriesCanvas!: ElementRef<HTMLCanvasElement>;
    public caseCategoriesContext: any;

    numberOfCasesInLast12Months: number = 0;
    numberOfTribunalsInLast12Months: number = 0;
    interactions: number = 0;

    emptyCaseTypesPie: boolean = true;
    emptyBar: boolean = true;
    emptyCaseCategoriesPie: boolean = true;

    constructor(
        private service: DashboardService,
        private chartService: DashboardChartService,
        private router: Router,
        private cdr: ChangeDetectorRef) {
    }

    ngAfterViewInit() {
        this.caseTypesContext = this.caseTypesCanvas.nativeElement.getContext('2d');
        this.caseCategoriesContext = this.caseCategoriesCanvas.nativeElement.getContext('2d');
        this.casesTotalContext = this.casesTotalsCanvas.nativeElement.getContext('2d');
        this.loadDashboardData();
    }


    loadDashboardData() {
        this.service.getDashboardManagementInformationData(this.service.getTierThreeDashboardEndpoint()).then((response: any) => {
            const caseTypesChartLabels = response.caseTypeCaseCounts.map((item) => { return item.description });
            const caseTypesChartData = response.caseTypeCaseCounts.map((item) => { return item.count });

            const caseCategoriesChartLabels = response.caseTypeCategoryCounts.map((item) => { return item.description });
            const caseCategoriesChartData = response.caseTypeCategoryCounts.map((item) => { return item.count });

            const casesTotalChartLabels = response.caseTotalCounts.map((item) => { return item.description });
            const casesTotalChartData = response.caseTotalCounts.map((item) => { return item.count });

            this.emptyBar = casesTotalChartData.length == 0;
            this.emptyCaseTypesPie = caseTypesChartData.length == 0;
            this.emptyCaseCategoriesPie = caseCategoriesChartData.length == 0;

            if (!this.emptyBar) {
                this.casesTotalChart = this.chartService.createBarChart(
                    this.casesTotalContext,
                    {
                        labelsList: casesTotalChartLabels,
                        data: casesTotalChartData,
                        displayLegend: true,
                        onClick: (label: string) => {
                            this.router.navigate(['my-cases'], {
                                queryParams: { caseStatusFilter: label }
                            });
                        }
                    }
                );
            }

            if (!this.emptyCaseTypesPie) {
                this.caseTypesChart = this.chartService.createPieChart(
                    this.caseTypesContext,
                    {
                        labelsList: caseTypesChartLabels,
                        data: caseTypesChartData,
                        displayLegend: true,
                        onClick: (label: string) => {
                            this.router.navigate(['my-cases'], {
                                queryParams: { caseTypeFilter: label }
                            });
                        }
                    }
                );
            }

            if (!this.emptyCaseCategoriesPie) {
                this.caseCategoriesChart = this.chartService.createPieChart(
                    this.caseCategoriesContext,
                    {
                        labelsList: caseCategoriesChartLabels,
                        data: caseCategoriesChartData,
                        displayLegend: true,
                        // onClick: (label: string) => {
                        //     this.router.navigate(['my-cases'], {
                        //         queryParams: { caseTypeFilter: label }
                        //     });
                        // }
                    }
                );
            }


            this.numberOfCasesInLast12Months = response.caseCount;
            this.numberOfTribunalsInLast12Months = response.tribunalCount;
            this.interactions = response.interactionsCount;
            this.cdr.markForCheck();
        });
    }





}
